// Top IP RTT V1; 2026-10-12 22:01:08 CST; parent b4911ce125fd2d2d4ec0a43767621bf719845f5b.
/** Missing telemetry is never a measured zero; preserve sub-millisecond samples. */
export function formatRtt(value: number | null | undefined, samples: number | null | undefined): string {
  if (typeof samples !== 'number' || !Number.isFinite(samples) || samples <= 0 ||
      typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return '—';
  return `${Number(value.toFixed(3))} ms`;
}
